import { atom } from 'recoil';

export const sbatGroupPlaylistContent = atom({
  key: 'sbatGroupPlaylistContent',
  default: '',
});
